// AppRedirect.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AppRedirect = () => {
  const location = useLocation();

  useEffect(() => {
     // Get the full URL (including path and query string)
    const fullPath = location.pathname + location.search;
    const deepLinkUrl = window.location.origin + fullPath;
    // const fullPath = location.pathname; // e.g., /open/product/123
    // const deepLinkUrl = `https://yourdomain.com${fullPath}`;

    const userAgent = navigator.userAgent;
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    const fallbackUrl = isAndroid
      ? "https://play.google.com/store/apps/details?id=com.trukkeruae.trukker_vender"
      : "https://apps.apple.com/us/app/trukker-partner/id1624013412";

      const hasRedirected = sessionStorage.getItem("redirected");

    if (isMobile && !hasRedirected) {
      sessionStorage.setItem("redirected", "true");
    // fallback in case OS doesn't handle it
      const timeout = setTimeout(() => {
      // iOS/Android will handle it if app supports App Links / Universal Links
    window.location.href = fallbackUrl;
      }, 1500);

      return () => clearTimeout(timeout);
    }

  }, [location]);

  return <p>Redirecting to the app...</p>;
};

export default AppRedirect;